import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within SettingsProvider');
  }
  return context;
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    logo_url: 'https://customer-assets.emergentagent.com/job_34f43037-f49f-4896-a120-3461406a9d35/artifacts/wh0yojmq_e30d7691-c116-46a6-b645-fa81d1964b10-removebg-preview.png',
    hero_title: 'Quality homes, built to last.',
    hero_subtitle: 'Discover premium residential apartments designed for modern living in Nagpur',
    stat_1_number: '15+',
    stat_1_label: 'Years of Experience',
    stat_2_number: '25+',
    stat_2_label: 'Projects Delivered',
    stat_3_number: '500+',
    stat_3_label: 'Happy Families',
    about_text: 'Infinity Group - We don\'t just build homes, we believe in creating a happy vibrant community in Nagpur.',
    footer_description: 'Quality homes, built to last. Your trusted partner in finding the perfect residential apartment in Nagpur.',
    primary_color: '#C41E3A',
    secondary_color: '#8B2635',
    why_us_title: 'Why Choose Infinity Group?',
    why_us_description: 'With over a decade of experience in building quality residential apartments in Nagpur, we\'ve earned the trust of thousands of families.',
    why_us_content: 'Founded in 2010, Infinity Group has been at the forefront of residential real estate development in Nagpur. With a commitment to excellence and innovation, we\'ve successfully delivered over 25 projects, providing homes to more than 500 families.',
    founder_message: 'At Infinity Group, we don\'t just build apartments; we build dreams. Every project is a testament to our commitment to quality, transparency, and customer satisfaction in Nagpur.',
    founders: [
      { name: 'Mr Ashay Nalamwar', title: 'Co-Founder', phone: '+919511611575', whatsapp: '919511611575' }
    ],
    show_phone_numbers: true,
    show_email: true,
    show_address: true,
    show_instagram: true,
    contact_email: 'homes.infinitygroup@gmail.com',
    contact_address: 'Nagpur, Maharashtra, India',
    instagram_handle: '@infinity_group.ngp',
    instagram_url: 'https://www.instagram.com/infinity_group.ngp',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
      
      // Apply colors to CSS variables
      document.documentElement.style.setProperty('--primary-color', response.data.primary_color);
      document.documentElement.style.setProperty('--secondary-color', response.data.secondary_color);
    } catch (error) {
      console.error('Error fetching settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
